/**
 * Utilidades de HTML seguro.
 *
 * `escapeHtml` neutraliza los caracteres con significado en HTML para insertar
 * texto de origen no confiable (nombres, motivos, datos de entidad) dentro de
 * marcado sin riesgo de inyección. Se usa al interpolar variables en los
 * cuerpos de correo HTML (ver `core/mail/mailRenderer.interpolarHtml`).
 */

/** Escapa `& < > " '` para insertar `s` de forma segura en HTML/atributos. */
export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
